const QUERY_PARAMS = {
  BRANCH_NAME: "bt-branch-name",
  THEME_NAME: "bt-theme-name",
  ENVIRONMENT_NAME: "bt-environment-name",
  BRAND_ID: "bt-brand-id",
};

export default QUERY_PARAMS;
